import { createFileRoute } from "@tanstack/react-router";
import { sendblueEnvironmentRoutesApiRoute } from "@/features/kits-environments";

export const Route = createFileRoute(
    "/api/internal/sendblue/environment-routes",
)({
    ...sendblueEnvironmentRoutesApiRoute,
});
